/** Move an item from one index to another (e.g. drag file 1 onto position 3). */
export const reorderListItems = (list, fromIndex, toIndex) => {
  if (!Array.isArray(list) || fromIndex === toIndex) return list;
  if (
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= list.length ||
    toIndex >= list.length
  ) {
    return list;
  }
  const next = [...list];
  const [removed] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, removed);
  return next;
};
